import { UPDATE_LOGIN, UPDATE_PROFILE, UPDATE_ROLE_NAMES } from "../../actionTypes/profile";

/*
  Logins from before the server stopped sending cPassword still carry it in
  storage. Drop it on load, and write the cleaned record back, so it does not
  linger until the next login.
*/
const loadLogin = () => {
  for (const store of [sessionStorage, localStorage]) {
    let rows = null;
    try { rows = JSON.parse(store.getItem("login")); } catch (e) { rows = null; }
    if (!Array.isArray(rows) || !rows.length) continue;
    if (rows.some((r) => r && "cPassword" in r)) {
      rows = rows.map(({ cPassword, ...rest }) => rest);
      try { store.setItem("login", JSON.stringify(rows)); } catch (e) { }
    }
    return rows;
  }
  return [];
};

const intialState = {
  loginState: loadLogin(),
  profile: [],
  roleNames: []
};

export default function LoaderReducers(state = intialState, action) {
  switch (action.type) {

    case UPDATE_LOGIN:
      return { ...state, loginState: action.payload };

    case UPDATE_PROFILE:
      return { ...state, profile: action.payload };

    case UPDATE_ROLE_NAMES:
      return { ...state, roleNames: action.payload };

    default:
      return state;
  }
}
